import { render, staticRenderFns } from "./ProductInfoElement.vue?vue&type=template&id=627eede6&scoped=true&"
import script from "./ProductInfoElement.vue?vue&type=script&lang=js&"
export * from "./ProductInfoElement.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoElement.vue?vue&type=style&index=0&id=627eede6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627eede6",
  null
  
)

export default component.exports